import { render, staticRenderFns } from "./vehicle-access.vue?vue&type=template&id=4dc14256&scoped=true"
import script from "./vehicle-access.vue?vue&type=script&lang=js"
export * from "./vehicle-access.vue?vue&type=script&lang=js"
import style0 from "./vehicle-access.vue?vue&type=style&index=0&id=4dc14256&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_d79148f6156699cf80ef22aa45ce0a5c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc14256",
  null
  
)

export default component.exports